import { render, staticRenderFns } from "./cadmetas.vue?vue&type=template&id=a145d506"
import script from "./cadmetas.vue?vue&type=script&lang=js"
export * from "./cadmetas.vue?vue&type=script&lang=js"
import style0 from "./cadmetas.vue?vue&type=style&index=0&id=a145d506&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports